import urlHelper from '../helpers/url'
import { model } from '../core/model'
import { Config } from '../core/config'
import Logout from '../controllers/logout'
import Analytics from '../helpers/analytics'
import YaTiene from '../controllers/yaTiene'
import CookieHelper from '../../common/helpers/cookieHelper'

const bind = () => {
    window.removeEventListener("storage", localStorageListener);
    window.addEventListener("storage", localStorageListener);

    document.querySelectorAll('.next-button').forEach((btn) => {
        btn.removeEventListener('click', clickListener);
        btn.addEventListener('click', clickListener)
    })
    document.querySelectorAll('.event-track').forEach((btn) => {
        btn.removeEventListener('click', clickListenerforHREFS);
        btn.addEventListener('click', clickListenerforHREFS)
    })
}

const localStorageListener = (event) => {
    if (event.key !== 'userLogedIn') return; // ignore other keys
    var message = JSON.parse(event.newValue);
    if (!message) return; // ignore empty msg or msg reset

    if (message === true) {
        model.Usuario.initModel()
        if (model.Usuario.hasAccesoDigital()) {
            YaTiene();
        }
    }
}

const clickListener = (event) => {
    let dataset = event.target.dataset;
    let { name, price, combo, step, skn, features } = dataset;
    let listaDeBeneficios = [];
    if (features) {
        listaDeBeneficios = JSON.parse(features);
    }
    const urlIngresarRegistracion = Config.dominioIngresarRegistracion;
    const { contact, canalVenta } = model.Window;
    const item = {
        id: combo,
        name: name,
        category: model.Window.source,
        price: price
    };

    switch (step) {
        case 'combo_procesar':
            Analytics.clearEcommerce();
            Analytics.clickCombo(price, canalVenta, contact, isClub(listaDeBeneficios), item);
            validateSesion(
                () => {
                    urlHelper.redirectToCombo(combo, null, skn);
                },
                () => {
                    urlHelper.redirectToLoginWCombo(combo, urlIngresarRegistracion, null, skn);
                }
            )
            break;

        case 'combo_procesar_bonificado':
            Analytics.clickCombo3(model.Window.source);
            break;
        case 'bannerVincular':
            Analytics.clickCombo3(model.Window.source);
            validateSesion(
                () => {
                    if (CookieHelper.readCookie('Crm_id') && CookieHelper.readCookie('Crm_id') != '') {
                        let divToastErrorCallCenter = document.getElementById('errorCallCenter');
                        divToastErrorCallCenter.className = 'errorCallCenter__animacion__visible';
                    } else {
                        urlHelper.redirectToCombo(combo);
                    }
                },
                () => {
                    urlHelper.redirectToLoginWCombo(combo, Config.dominioIngresarDefault)
                }
            )
            break;
        case 'redirect':
            urlHelper.redirect(dataset.url);
            break;
        //TODO: se puede iniciar sesion sin ser suscriptor
        case 'ya_tenes_suscripcion':
            Analytics.clickYaTengoSuscripcion();
            urlHelper.redirectToLoginWAction(model.Window.modo, model.Window.combo);
            break;
        case 'logout':
            Logout(true).then(() => {
                console.log("logout finished")
                //urlHelper.redirectToLogin();
                //urlHelper.redirectToLoginWAction(Config.ACCION_YA_TIENE_SUSCRIPCION);
            });
            break;
        case 'bannerFamiliar':
        case 'combo_familiar':
            event.preventDefault();
            //console.log(Config.modoWallFamiliar, Config.PRODUCTO_NOTA);
            urlHelper.redirectToWall(Config.modoWallFamiliar, Config.PRODUCTO_NOTA);
            break;
        case 'landing':
            Analytics.trackViewLanding(name, price);
            validateSesion(
                () => {
                    urlHelper.redirectToCombo(combo, dataset.campaign);
                },
                () => {
                    urlHelper.redirectToLoginWCombo(combo, null, dataset.campaign);
                }
            );
            break;
        case 'continue_reading':
            if (skn.toUpperCase() === "GRACIAS") {
                const urlParams = new URLSearchParams(window.location.search);
                const callbackValue = urlParams.get("callback");
                callbackValue !== null ? urlHelper.redirect(window.atob(callbackValue)) : urlHelper.redirect(Config.defaultRedirectUrl);
            }
            break;
        default:
            window.mostrar_error({
                error: `action.clickListener | event.target.dataset.step no atrapado. ${step}`
            })
    }
}

const clickListenerforHREFS = (event) => {
    event.preventDefault();
    const href = event.currentTarget.href;
    const label = event.currentTarget.dataset.label;
    Analytics.otrosEnlaces(label);
    location.href = href;
}


const validateSesion = (logued, notLogued) => {
    model.Usuario.isLogged().then(isLogged => {
        if (isLogged) {
            logued && logued();
        }
        else {
            notLogued && notLogued();
        }
    })
}

const isClub = (beneficios) =>
    beneficios.some(
        (beneficio) =>
            beneficio.toLowerCase().includes("club") && tieneBeneficio(beneficio)
    );

// Las features que vienen por parametro poseen el primer caracter del string que es un 0 o 1,
// este valor lo tomamos como booleanos para ver si el combo tiene incluida la feature o no.
const tieneBeneficio = (beneficio) => beneficio[0] == true;

export default {
    bind,
};




// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/action.js